import React from "react";
import { NavLink } from "react-router-dom";
import PageHeader from "@/components/common/PageHeader";
import { Card } from "@/components/ui/card";
import { ShieldCheck, Receipt, FileText, ScrollText, Landmark, Calendar } from "lucide-react";

const TILES = [
  { to: "/app/gst-registers", icon: Receipt, title: "GST",
    desc: "GSTR-1 / GSTR-3B registers, e-invoicing, e-way bill, ITC reconciliation.", tag: "Live" },
  { to: "/app/tds", icon: FileText, title: "TDS + 26AS",
    desc: "TDS deductions per new IT Act 2025 sections, challan mapping, Form 26AS reconciliation with auto-JV.", tag: "Live" },
  { to: "/app/tax-audit", icon: ScrollText, title: "Tax Audit · 3CA / 3CB · 3CD",
    desc: "44 clauses with ledger pre-fill and CBDT utility JSON export.", tag: "Live" },
  { to: "/app/corporate-compliance", icon: Landmark, title: "Corporate Compliance",
    desc: "MGT-7, AOC-4, DPT-3, DIR-3 KYC, Form 8, Form 11 wizards with MCA JSON export.", tag: "Live" },
  { to: "/app/itr", icon: FileText, title: "ITR",
    desc: "Auto-prepared computation + JSON export for the ITD utility.", tag: "Phase 4" },
  { to: "/app/compliance-calendar", icon: Calendar, title: "Compliance Calendar",
    desc: "Every statutory due-date in one view. Email + WhatsApp reminders.", tag: "Live" },
];

export default function ComplianceHub() {
  return (
    <div className="p-6 lg:p-8 space-y-6" data-testid="compliance-hub-page">
      <PageHeader eyebrow="Regulatory" title="Compliance Management"
        description="Every statutory workflow in one place — Direct + Indirect tax, Companies Act, LLP Act, MCA filings." />
      <div className="grid md:grid-cols-3 gap-4">
        {TILES.map((t) => (
          <NavLink key={t.to} to={t.to} className="block" data-testid={`compliance-tile-${t.title.toLowerCase().replace(/[^a-z]+/g, '-')}`}>
            <Card className="p-5 rounded-sm hover:border-accent hover:shadow-lg transition-all cursor-pointer h-full">
              <div className="flex items-start justify-between">
                <t.icon className="w-6 h-6 text-accent" />
                <span className={`text-[10px] font-mono uppercase tracking-widest px-2 py-0.5 rounded-sm ${t.tag === "Live" ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>{t.tag}</span>
              </div>
              <div className="mt-4 font-semibold">{t.title}</div>
              <div className="text-xs text-muted-foreground mt-1">{t.desc}</div>
            </Card>
          </NavLink>
        ))}
      </div>
      <div className="card-sharp p-6">
        <div className="flex items-start gap-3">
          <ShieldCheck className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" />
          <div className="text-sm text-muted-foreground">
            Corporate Compliance forms scoped for v1: <b>MGT-7 / 7A, AOC-4, DPT-3, FLA Return, DIR-3 KYC, MSME-1, BEN-2, ADT-1, INC-20A, PAS-6</b> (Companies) and <b>Form 8, Form 11, Form 3, Form 4, Form 24</b> (LLP). Every form has an input wizard, PDF preview and JSON/XML export for MCA portal.
          </div>
        </div>
      </div>
    </div>
  );
}
